const TONES = {
  ghost:  { bg: "transparent", color: "var(--ink-3)", border: "transparent", hover: "var(--paper-2)" },
  filled: { bg: "var(--paper-2)", color: "var(--ink-2)", border: "var(--line)", hover: "var(--paper-3)" },
  star:   { bg: "var(--accent-soft)", color: "var(--accent)", border: "var(--accent)", hover: "var(--accent-soft)" },
};

export default function IconBtn({ icon: Icon, title, onClick, disabled, size = 14, tone = "ghost", style }) {
  const t = TONES[tone];
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={(e) => { if (!disabled) e.currentTarget.style.background = t.hover; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = t.bg; }}
      style={{
        width: 24,
        height: 24,
        borderRadius: 6,
        border: `1px solid ${t.border === "transparent" ? "transparent" : t.border}`,
        background: t.bg,
        color: disabled ? "var(--ink-4)" : t.color,
        cursor: disabled ? "default" : "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 0,
        flexShrink: 0,
        transition: "background 0.12s",
        ...style,
      }}
    >
      <Icon size={size} stroke="currentColor" />
    </button>
  );
}
